import Popover from '@stimulus-components/popover'

// Connects to data-controller="popover"
export default class extends Popover {
  connect() {
    super.connect()
  }
}
